(function() {
    'use strict';
    angular.module('cabinFlightAdmin').service('cabinFlightAdminService', cabinFlightAdminService);

    function cabinFlightAdminService(RemoteService, CommonMasterData, CabinFlightAdminFactory, $http) {
        var self = this;

        self.adaptCrewList = function(crewList) {
            angular.forEach(crewList, function(crew) {
                crew.displayName = crew.firstName + ' ' + crew.lastName + ' (' + crew.crewId + ')';
            });
            return crewList;
        };

        self.searchCabinCrews = function(param, successFn, errorFn) {
            var formatedData = CabinFlightAdminFactory.formatSearchParams(param);
            RemoteService.searchCabinFlights(formatedData).then(function(response) {
                successFn(response);
            }, function(error) {
                errorFn(error);
            });
        };

        self.getEditFlightPopUpDetails = function(param, successFn, errorFn) {
            RemoteService.loadEditPanelCabinFlightData(param).then(function(response) {
                var formattedData = CabinFlightAdminFactory.formatEditPanelResponse(response);
                successFn(formattedData);
            }, function(error) {
                errorFn(error);
            });
        };

        self.getCabinFlights = function(successFn, errorFn) {
            RemoteService.getCabinFlights().then(function(response) {
                successFn(response);
            }, function(error) {
                errorFn(error);
            });
        };

        self.approveCabinFlight = function(param, successFn, errorFn) {
            RemoteService.approveCabinFlight(param).then(function(response) {
                successFn(response);
            }, function(error) {
                errorFn(error);
            });
        }
        self.saveOrUpdateCabinFlight = function(param, successFn, errorFn) {
            var formattedData = CabinFlightAdminFactory.formatEditPanelRequest(param);
            RemoteService.saveOrUpdateCabinFlight(formattedData).then(function(response) {
                successFn(response);
            }, function(error) {
                errorFn(error);
            });
        };
        self.deleteCabinFlightEntry = function(param, successFn, errorFn) {
            RemoteService.deleteCabinFlightEntry(param).then(function(response) {
                successFn(response);
            }, function(error) {
                errorFn(error);
            });
        };

        self.getDepartments = function (successFn, errorFn) {
        	RemoteService.getDepartments().then(
        			function (response) {
        				successFn(response);
        			},
        			function (error) {
        				errorFn(error)
        			}
        	)
        };
      self.getCrewingPriviledges = function(successFn,errorFn){
          RemoteService.getCrewingPriviledges().then(
            function (response) {
              successFn(response.crewingPriviledgesDTO);
            },function (error) {
              errorFn(error)
            }
          );
      }

      self.getCabinFlightReportRemarkList = function(reportId, successFn, errorFn) {
        RemoteService.getCabinFlightReportRemarkList(reportId).then(function(response) {
          successFn(response);
        }, function(error) {
          errorFn(error);
        });
      }

      self.updateCabinFlightReportFeedback = function(param, successFn, errorFn) {
        RemoteService.updateCabinFlightReportFeedback(param).then(function(response) {
          successFn(response);
        }, function(error) {
          errorFn(error);
        });
      }

      self.sendCabinFlightReportFeedback = function(param, successFn, errorFn) {
        RemoteService.sendCabinFlightReportFeedback(param).then(function(response) {
          successFn(response);
        }, function(error) {
          errorFn(error);
        });
      }

      self.getRemarkImageUrl = function(objectName, successFn, errorFn) {
        RemoteService.getRemarkImageUrl(objectName).then(function(response) {
          successFn(response);
        }, function(error) {
          errorFn(error);
        });
      }

      self.uploadRemarkImage = function(formData, successFn, errorFn) {
        $http.post('/admin/aeroLineCrewAdmin/reportService/cabin/remark/upload/image',
          formData,
          { headers: { 'Content-Type': undefined } }
        ).then(function(response) {
          successFn(response.data);
        }, function(error) {
          errorFn(error);
        });
      }

    }
})();
